<script setup lang="ts">
import HeroSection from '../components/HeroSection.vue';
import AboutSection from '../components/AboutSection.vue';
import SkillsSection from '../components/SkillsSection.vue';
import ProjectsSection from '../components/ProjectsSection.vue';
import BlogSection from '../components/BlogSection.vue';
import ContactSection from '../components/ContactSection.vue';
</script>

<template>
  <div class="home-page">
    <HeroSection />
    <AboutSection />
    <SkillsSection />
    <ProjectsSection />
    <BlogSection />
    <ContactSection />
  </div>
</template>

<style scoped>
.home-page {
  width: 100%;
}
</style>
